"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashToCamelCase = dashToCamelCase;
function dashToCamelCase(str) {
    return str.replace(/-([a-z])/gi, (match, letter) => letter.toUpperCase());
}
